var _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 52.5H7V70.5H27V52.5Z",
    fill: "#93B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34.5H30V70.5H50V34.5Z",
    fill: "#5B8BF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10.5H53V70.5H73V10.5Z",
    fill: "#2F68E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58.5C19.0115 51.2473 36.9828 65.2143 40 39.5C43.0172 13.7857 56 26.5 63 14.5",
    stroke: "#224CCA",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 58,
    r: 4,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 41.5,
    r: 4,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 16.5,
    r: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnLine);
export default __webpack_public_path__ + "static/media/column-line.5a38a4a1153282cb22101ed31ef26d56.svg";
export { ForwardRef as ReactComponent };